import { useState } from 'react';

// COMPONENTS
import CheckboxInput from 'components/CheckboxInput';

// ICONS
import { X } from 'lucide-react';

export default function ProposeTileModal({ isOpen, onClose, onSubmit }) {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        link: '',
        availableForPresta: false,
        requiresVPN: false,
        justification: '',
        proposalId: null
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-noir/50 dark:bg-dark/70 flex items-center justify-center z-50">
            <div className="bg-blanc dark:bg-noir rounded-xl p-6 w-full max-w-2xl relative">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 p-2 rounded-lg hover:bg-noir/10 dark:hover:bg-gris/40"
                >
                    <X className="size-6 text-noir dark:text-blanc" />
                </button>

                <h2 className="text-2xl font-bold text-noir dark:text-blanc mb-6">Proposer une tuile</h2>

                <form autoComplete="off" onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-noir dark:text-blanc mb-2">Titre *</label>
                        <input
                            type="text"
                            maxLength={32}
                            required
                            className="w-full px-3 py-2 rounded-md border border-gray-300 dark:border-gray-600 dark:bg-dark focus:outline-none focus:ring-orange focus:border-orange dark:focus:ring-orange dark:focus:border-orange"
                            value={formData.title}
                            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                            placeholder="Ex: Trombino"
                        />
                    </div>

                    <div>
                        <label className="block text-noir dark:text-blanc mb-2">Description *</label>
                        <textarea
                            maxLength={255}
                            required
                            className="w-full px-3 py-2 rounded-md border border-gray-300 dark:border-gray-600 dark:bg-dark focus:outline-none focus:ring-orange focus:border-orange dark:focus:ring-orange dark:focus:border-orange"
                            value={formData.description}
                            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                            placeholder="Ex: Localisez facilement vos collègues & salles de réunion"
                        />
                    </div>

                    <div>
                        <label className="block text-noir dark:text-blanc mb-2">Lien *</label>
                        <input
                            type="url"
                            maxLength={1000}
                            required
                            className="w-full px-3 py-2 rounded-md border border-gray-300 dark:border-gray-600 dark:bg-dark focus:outline-none focus:ring-orange focus:border-orange dark:focus:ring-orange dark:focus:border-orange"
                            value={formData.link}
                            onChange={(e) => setFormData({ ...formData, link: e.target.value })}
                            placeholder="Ex: https://trombino.altitudeinfra.fr/"
                        />
                    </div>

                    <div className="flex items-center gap-2">
                        
                        <CheckboxInput
                            id="availableForPresta"
                            name="availableForPresta"
                            checked={formData.availableForPresta}
                            onChange={(e) => setFormData({ ...formData, availableForPresta: e.target.checked })}
                            label="Accessible aux prestataires externes"
                        />
                    </div>

                    <div className="flex items-center gap-2">
                        <CheckboxInput
                            id="requiresVPN"
                            name="requiresVPN"
                            checked={formData.requiresVPN}
                            onChange={(e) => setFormData({ ...formData, requiresVPN: e.target.checked })}
                            label="Nécessite un accès VPN/Intranet"
                        />
                    </div>

                    <div>
                        <label className="block text-noir dark:text-blanc mb-2">Justification *</label>
                        <textarea
                            required
                            className="w-full px-3 py-2 rounded-md border border-gray-300 dark:border-gray-600 dark:bg-dark focus:outline-none focus:ring-orange focus:border-orange dark:focus:ring-orange dark:focus:border-orange"
                            value={formData.justification}
                            onChange={(e) => setFormData({ ...formData, justification: e.target.value })}
                        />
                    </div>

                    <div className="flex justify-end gap-4 mt-6">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 rounded-lg hover:bg-red-100 dark:hover:bg-red-900 text-noir dark:text-blanc"
                        >
                            Annuler
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 rounded-lg bg-green-100 dark:bg-green-900 hover:bg-green-200 dark:hover:bg-green-800 text-noir dark:text-blanc"
                        >
                            Soumettre
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
} 